/* Angry Arc — snorkel selection gate + custom-colour capture
 * All customer-facing wording is read from window.__SNORKEL_TEXT (set in the
 * "Selection gate" block) so the store owner can edit it without touching code.
 * Perf: observes ONLY the variant picker and debounces with requestAnimationFrame. */
(function () {
  'use strict';
  var CFG = window.__SNORKEL_TEXT || {};
  var CUSTOM_VALUE = CFG.customOptionValue || 'Custom Powder Coat';
  var PROP_NAME = 'properties[' + (CFG.propertyName || 'Custom colour details') + ']';
  var MSG_OPTIONS = CFG.selectPrompt || 'Please choose a finish and a coating before adding to cart.';
  var MSG_CUSTOM = CFG.customPrompt || 'Please enter your custom colour details (colour code, finish, texture) to continue.';
  var FIELD_LABEL = CFG.customLabel || 'Custom colour details';
  var FIELD_PLACEHOLDER = CFG.customPlaceholder || 'Colour code, finish (gloss/satin/matte/textured), texture, any reference…';
  var touched = {};
  var busy = false;
  var scheduled = {};

  function esc(s) {
    if (window.CSS && CSS.escape) return CSS.escape(s);
    return String(s).replace(/["\\\]]/g, '\\$&');
  }
  function pickerFor(sid) { return document.querySelector('variant-picker[data-section-id="' + esc(sid) + '"]'); }
  function formFor(sid) { return document.querySelector('product-form-component[data-section-id="' + esc(sid) + '"]'); }

  function optionNames(picker) {
    var out = [];
    picker.querySelectorAll('input[type="radio"]').forEach(function (r) {
      if (r.name && out.indexOf(r.name) === -1) out.push(r.name);
    });
    return out;
  }

  function ensureHint(form) {
    var h = form.querySelector('.snorkel-gate-hint');
    if (h) return h;
    h = document.createElement('div');
    h.className = 'snorkel-gate-hint';
    h.setAttribute('role', 'status');
    h.style.cssText = 'margin:0 0 10px;font-size:.9rem;line-height:1.3;color:#b91c1c;';
    var anchor = form.querySelector('.product-form-buttons');
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(h, anchor);
    else form.insertBefore(h, form.firstChild);
    return h;
  }

  function ensureCustomField(form, sid) {
    var wrap = form.querySelector('.snorkel-custom-field');
    if (wrap) return wrap;
    wrap = document.createElement('div');
    wrap.className = 'snorkel-custom-field';
    wrap.style.cssText = 'margin:0 0 14px;display:none;';
    var label = document.createElement('label');
    label.textContent = FIELD_LABEL;
    label.style.cssText = 'display:block;font-weight:600;margin:0 0 6px;font-size:.95rem;';
    var ta = document.createElement('textarea');
    ta.setAttribute('name', PROP_NAME);
    ta.setAttribute('rows', '3');
    ta.setAttribute('placeholder', FIELD_PLACEHOLDER);
    ta.style.cssText = 'width:100%;box-sizing:border-box;padding:10px;border:1px solid var(--color-border,#999);border-radius:8px;font:inherit;';
    ta.disabled = true;
    label.setAttribute('for', 'snorkel-custom-' + sid);
    ta.id = 'snorkel-custom-' + sid;
    wrap.appendChild(label);
    wrap.appendChild(ta);
    var anchor = form.querySelector('.snorkel-gate-hint') || form.querySelector('.product-form-buttons');
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(wrap, anchor);
    else form.insertBefore(wrap, form.firstChild);
    ta.addEventListener('input', function () { schedule(sid); });
    return wrap;
  }

  function gate(form, open, message) {
    var btn = form.querySelector('[ref="addToCartButton"]') || form.querySelector('button[name="add"]');
    var hid = form.querySelector('input[name="id"]');
    var dyn = form.querySelector('.shopify-payment-button');
    var h = ensureHint(form);
    if (open) {
      if (btn) btn.removeAttribute('disabled');
      if (dyn) { dyn.style.pointerEvents = ''; dyn.style.opacity = ''; }
      h.style.display = 'none';
    } else {
      if (btn) btn.setAttribute('disabled', '');
      if (hid) hid.value = '';
      if (dyn) { dyn.style.pointerEvents = 'none'; dyn.style.opacity = '.4'; }
      h.textContent = message || MSG_OPTIONS;
      h.style.display = '';
    }
  }

  function reconcile(sid) {
    if (busy) return;
    busy = true;
    try {
      var picker = pickerFor(sid), form = formFor(sid);
      if (picker && form) {
        var names = optionNames(picker);
        if (names.length) {
          var t = touched[sid] || (touched[sid] = {});
          names.forEach(function (name) {
            if (!t[name]) {
              picker.querySelectorAll('input[type="radio"][name="' + esc(name) + '"]').forEach(function (r) {
                if (r.checked) r.checked = false;
                r.setAttribute('data-current-checked', 'false');
              });
            }
          });
          var allChosen = names.every(function (name) { return t[name]; });
          var customSelected = !!picker.querySelector('input[type="radio"]:checked[value="' + esc(CUSTOM_VALUE) + '"]');
          var field = ensureCustomField(form, sid);
          var ta = field.querySelector('textarea');
          if (customSelected) { field.style.display = ''; if (ta) ta.disabled = false; }
          else { field.style.display = 'none'; if (ta) ta.disabled = true; }
          var customOk = !customSelected || (ta && ta.value.trim().length > 0);
          var open = allChosen && customOk;
          var msg = !allChosen ? MSG_OPTIONS : (!customOk ? MSG_CUSTOM : '');
          gate(form, open, msg);
        }
      }
    } catch (e) {}
    busy = false;
  }

  function schedule(sid) {
    if (scheduled[sid]) return;
    scheduled[sid] = true;
    requestAnimationFrame(function () { scheduled[sid] = false; reconcile(sid); });
  }

  function setup(form) {
    var sid = form.getAttribute('data-section-id');
    if (!sid || form.__snorkelGate) return;
    var picker = pickerFor(sid);
    if (!picker || !picker.querySelector('input[type="radio"]')) return;
    form.__snorkelGate = true;
    touched[sid] = touched[sid] || {};
    reconcile(sid);
    if (window.MutationObserver) {
      new MutationObserver(function () { schedule(sid); })
        .observe(picker, { childList: true, subtree: true });
    }
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.tagName !== 'INPUT' || t.type !== 'radio') return;
    var picker = t.closest('variant-picker');
    if (!picker) return;
    var sid = picker.getAttribute('data-section-id');
    if (!sid) return;
    (touched[sid] || (touched[sid] = {}))[t.name] = true;
    schedule(sid);
  }, true);

  function init() { document.querySelectorAll('product-form-component').forEach(setup); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  setTimeout(init, 800);
})();
